var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.$route.params.idCotizacion)?_c('Formulario_cotizacion'):_vm._e(),(!_vm.$route.params.idCotizacion)?_c('Interfaz_provedor'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }